export const CATEGORIES = [
  { id: "properties", label: "Properties", icon: "Building2", subcategories: ["Sale", "Rent", "Plot / Land"] },
  { id: "vehicles", label: "Vehicles", icon: "Car", subcategories: ["Cars", "Motorcycles", "Commercial Vehicles", "Other Vehicles"] },
  { id: "businesses", label: "Businesses", icon: "Briefcase", subcategories: ["Business for Sale", "Franchise", "Startup", "Shop / Space"] },
  { id: "architects", label: "Architects", icon: "PenTool", subcategories: ["Residential", "Commercial", "Landscape", "Urban Planning", "All type of work"] },
  { id: "contractors", label: "Contractors", icon: "HardHat", subcategories: ["Civil", "Electrical", "Plumbing", "Renovation", "All type of work"] },
  { id: "interior-designers", label: "Interior Designers", icon: "Palette", subcategories: ["Residential", "Commercial", "Modular Kitchen", "Office", "All type of work"] },
  { id: "event-services", label: "Event Services", icon: "PartyPopper", subcategories: ["All", "Wedding", "Corporate", "Birthday", "Photography", "Catering", "Decor", "DJ / Music", "Anniversary", "Other"] },
  { id: "travel-services", label: "Travel Services", icon: "Plane", subcategories: ["Tour Packages", "Car Rentals", "Hotels", "Travel Agents"] },
  { id: "education", label: "Education", icon: "GraduationCap", subcategories: ["School", "College", "Coaching Institute", "Study Center"] },
  { id: "healthcare", label: "Healthcare", icon: "HeartPulse", subcategories: ["Hospital", "Clinic", "Diagnostic Center", "Pharmacy", "Doctor (Individual)", "Physiotherapy & Rehab", "Home Healthcare", "Emergency Services", "Alternative Medicine", "Specialized Care"] },
  { id: "food", label: "Food", icon: "UtensilsCrossed", subcategories: ["Restaurant", "Cafe & Beverages", "Fast Food & Quick Bites", "Sweets & Bakery", "Catering & Tiffin", "Cloud Kitchen", "Street Food & Dhaba", "Banquet & Party Food", "Grocery & Daily Needs", "Specialty Food Stores"] },
  { id: "beauty", label: "Beauty", icon: "Sparkles", subcategories: ["Hair Services", "Makeup Services", "Nail Services", "Skin & Beauty", "Spa & Wellness", "Brows & Lashes", "Beauty Products", "Home Services", "Bridal & Wedding"] },
  { id: "fitness", label: "Fitness", icon: "Dumbbell", subcategories: ["Gym", "Yoga", "Personal Training", "Zumba & Dance Fitness", "Sports Training", "Online Fitness", "Diet & Nutrition", "Rehabilitation & Therapy"] },
  { id: "ev-charging", label: "EV Charging Station", icon: "Zap", subcategories: ["Public Charging", "Private Charging", "Fast Charging", "Home Charging Setup", "Commercial Charging"] },
];

// -------------------------------------------------------------
// Sub-type dropdown maps for Beauty / Fitness / EV (Step 1)
// -------------------------------------------------------------
export const BEAUTY_SUB_TYPES = {
  "Hair Services": ["Hair Salon", "Unisex Salon", "Barber Shop", "Hair Spa", "Hair Cut & Styling", "Hair Coloring", "Hair Straightening", "Hair Smoothening", "Hair Rebonding", "Hair Extensions", "Hair Treatment"],
  "Makeup Services": ["Bridal Makeup", "Party Makeup", "HD Makeup", "Airbrush Makeup", "Groom Makeup", "Fashion Makeup"],
  "Nail Services": ["Nail Art", "Nail Extensions", "Manicure", "Pedicure", "Nail Spa"],
  "Skin & Beauty": ["Facial", "Cleanup", "Bleach", "Detan", "Skin Polishing", "Hydra Facial", "Anti-Aging Treatment", "Acne Treatment"],
  "Spa & Wellness": ["Spa", "Body Massage", "Head Massage", "Aromatherapy", "Body Polishing"],
  "Brows & Lashes": ["Eyebrow Threading", "Eyelash Extensions", "Lash Lift", "Brow Lamination"],
  "Beauty Products": ["Cosmetics Store", "Skincare Products", "Hair Care Products", "Beauty Equipment", "Professional Salon Supplies"],
  "Home Services": ["Home Salon Services", "Freelance Makeup Artist", "Home Spa Services"],
  "Bridal & Wedding": ["Bridal Packages", "Groom Packages", "Mehndi Artist", "Pre-Bridal Packages", "Wedding Beauty Services"],
};

export const FITNESS_SUB_TYPES = {
  "Gym": ["Local Gym", "Premium Gym", "Ladies Gym", "24x7 Gym", "CrossFit Gym", "Strength Training Gym"],
  "Yoga": ["Yoga Classes", "Power Yoga", "Meditation Classes", "Prenatal Yoga", "Online Yoga Classes"],
  "Personal Training": ["Personal Gym Trainer", "Home Personal Trainer", "Online Personal Trainer", "Weight Loss Trainer", "Muscle Gain Trainer"],
  "Zumba & Dance Fitness": ["Zumba Classes", "Aerobics", "Dance Fitness", "Bollywood Dance Fitness"],
  "Sports Training": ["Cricket Coaching", "Football Coaching", "Swimming Classes", "Martial Arts", "Badminton Coaching"],
  "Online Fitness": ["Online Workout Programs", "Virtual Training", "Fitness Apps Coaching"],
  "Diet & Nutrition": ["Dietitian", "Nutritionist", "Weight Loss Plans", "Meal Planning"],
  "Rehabilitation & Therapy": ["Physiotherapy", "Injury Recovery", "Post Surgery Rehab"],
};

export const EV_SUB_TYPES = {
  "Public Charging": ["Highway Charging Station", "City Charging Station", "Mall Charging Station", "Parking Charging Station"],
  "Private Charging": ["Society Charging", "Office Charging", "Private Parking Charging"],
  "Fast Charging": ["DC Fast Charging", "Super Fast Charging", "Ultra Fast Charging"],
  "Home Charging Setup": ["Home Charger Installation", "Wall Box Charger", "Portable Charger"],
  "Commercial Charging": ["Fleet Charging", "Business Charging Setup", "Charging Franchise"],
};

export function subTypesFor(categoryId, subcategory) {
  if (!categoryId || !subcategory) return [];
  if (categoryId === "beauty") return BEAUTY_SUB_TYPES[subcategory] || [];
  if (categoryId === "fitness") return FITNESS_SUB_TYPES[subcategory] || [];
  if (categoryId === "ev-charging") return EV_SUB_TYPES[subcategory] || [];
  return [];
}
export const SUBTYPE_ENABLED_CATEGORIES = new Set(["beauty", "fitness", "ev-charging"]);

// -------------------------------------------------------------
// City / area configuration
// -------------------------------------------------------------
// Cities available across the wizard. NO "Other" per spec.
export const CITIES = ["Gurugram", "Pataudi", "Rewari", "Farrukhnagar", "Manesar", "Jhajjar", "Dharuhera", "Sohna"];

// Pataudi has a full village + town list. UI still exposes "Other" as final option.
export const PATAUDI_AREAS = [
  "Pataudi Town", "Haily Mandi",
  "Ahmedpur", "Balewa", "Bapas", "Barheri Rehnwa", "Bas Padamka", "Bastpur",
  "Bhogpuri", "Bir Khurd", "Chhajjnagar", "Chhillarki", "Dadawas", "Dararpur",
  "Daulatabad", "Dehlawas", "Gadaipur", "Gagali", "Ghilnawas", "Ghudana",
  "Goriyawas", "Haliyaki", "Hansaka", "Hakdarpur", "Heraheri", "Husaika",
  "Inchhapuri", "Jasat", "Khalilpur", "Khanpur", "Khetiyawas", "Khor",
  "Lohka", "Lohchap", "Lokra", "Lokhri", "Mangwaki", "Mao", "Mehaniyawas",
  "Milakpur", "Mirzapur", "Mojamabad", "Mubarakpur", "Mumtajpur",
  "Muzaffar Mandpura", "Nanu Khurd", "Nanukalan", "Narhera", "Noorgarh",
  "Pahari", "Rajpura", "Rampur", "Ransika", "Said Shahpur", "Sapedar Nagar",
  "Shahpur Jat", "Sherpur", "Telpuri", "Turkapur", "Uncha Majra",
];

// Free-form fallback per city (used only if the dynamic API fails).
export const LOCATIONS = {
  Gurugram: ["DLF Phase 1", "DLF Phase 2", "DLF Phase 3", "DLF Phase 4", "DLF Phase 5", "Sector 14", "Sector 15", "Sector 29", "Sector 31", "Sector 40", "Sector 45", "Sector 46", "Sector 47", "Sector 49", "Sector 56", "Sector 57", "Sushant Lok 1", "Sushant Lok 2", "Sushant Lok 3", "Golf Course Road", "MG Road", "Jacobpura", "Sadar Bazar", "New Colony", "Patel Nagar", "Jyoti Park", "Prem Nagar", "Sohna Road", "Badshahpur", "Wazirabad", "Kadarpur", "Manesar"],
  Pataudi: PATAUDI_AREAS,
  Farrukhnagar: ["Farrukhnagar Town", "Sultanpur", "Khera Khurrampur", "Dhanwapur", "Garhi Harsaru"],
  Rewari: ["Model Town", "Sector 1", "Sector 2", "Sector 3", "Sector 4", "Circular Road", "Bawal Road", "Nai Abadi", "Shastri Nagar", "Krishna Nagar", "Railway Road", "Bawal", "Dharuhera", "Kasola", "Khalilpur"],
  Manesar: ["IMT Manesar", "Sector 1", "Sector 2", "Sector 3", "Sector 4", "Sector 5", "Sector 6", "Sector 7", "Sector 8", "NH-48 Area", "Nakhrola", "Bas Kusla", "Kasan", "Kukdola", "Naharpur Kasan"],
  Jhajjar: ["Jhajjar City", "Sector 6", "Sector 7", "Sector 9", "Old City", "Bus Stand Area", "Beri Gate", "Beri", "Badli", "Dighal"],
  Dharuhera: ["Sector 1", "Sector 2", "Sector 3", "Sector 4", "Sector 5", "Sector 6", "Sector 7", "Sector 8", "Sector 9", "Sector 10", "Sector 11", "Sector 12", "Sector 13", "Sector 14", "Sector 15", "Sector 16", "Sector 17", "Sector 18", "Sector 19", "Sector 20", "Sector 21", "Sector 22", "Sector 23", "Sector 24", "Industrial Area", "NH-48 Area", "Chungi", "Market Area", "Kapriwas", "Bhiwadi", "Rewari", "Malpura"],
  Sohna: ["Sohna Road", "Sohna Chowk", "Mandi", "Old Sohna", "Bhondsi", "Damdama", "Ghamroj", "Raipur"],
};

// -------------------------------------------------------------
// Property flow configuration
// -------------------------------------------------------------
export const PROPERTY_LISTING_TYPES = [
  { v: "sale", l: "Sale" },
  { v: "rent", l: "Rent" },
];

export const PROPERTY_BUILDING_TYPES = [
  { v: "residential", l: "Residential" },
  { v: "commercial", l: "Commercial" },
];

export const PROPERTY_TYPES = {
  residential: ["Apartment", "Villa", "Plot", "Builder Floor", "Penthouse", "Independent House", "PG"],
  commercial: ["Office Space", "Shop", "Land", "Office in IT/SEZ", "Showroom", "Warehouse", "Industrial Plot", "Co-working Space"],
};

// Property types that behave like a "Plot" — no bedrooms/rooms/floors.
export const PLOT_LIKE_TYPES = new Set(["Plot", "Land", "Industrial Plot"]);

// -------------------------------------------------------------
// Vehicle configuration
// -------------------------------------------------------------
export const VEHICLE_BRANDS = [
  "Maruti Suzuki", "Hyundai", "Tata", "Mahindra", "Honda", "Toyota", "Kia", "Renault",
  "Skoda", "Volkswagen", "Ford", "Nissan", "MG", "Jeep", "BMW", "Mercedes-Benz", "Audi",
  "Hero", "Bajaj", "TVS", "Royal Enfield", "Yamaha", "Suzuki", "KTM",
];

export const FUEL_TYPES = ["Petrol", "Diesel", "CNG", "Electric", "Hybrid", "Other"];
export const TRANSMISSION_TYPES = ["Automatic", "Manual"];
export const OWNER_OPTIONS = ["1st", "2nd", "3rd", "4+"];

// -------------------------------------------------------------
// Business configuration
// -------------------------------------------------------------
export const BUSINESS_CATEGORIES = [
  "Retail Shop", "Restaurant / Cafe", "Grocery / Kirana", "Salon / Spa", "Boutique",
  "Manufacturing", "Wholesale / Distribution", "IT / Software", "Healthcare / Clinic",
  "Education / Coaching", "Fitness / Gym", "Auto Repair", "Real Estate Agency",
];

// -------------------------------------------------------------
// Category helpers
// -------------------------------------------------------------
export const PROFESSIONAL_CATEGORIES = ["architects", "contractors", "interior-designers", "event-services", "travel-services", "education", "healthcare", "food"];

// Categories that do NOT collect a price field.
export const NO_PRICE_CATEGORIES = new Set([
  "architects", "contractors", "interior-designers", "businesses", "travel-services",
  "education", "healthcare", "food", "beauty", "fitness", "ev-charging",
]);

// Size units for plot / land style properties.
export const PROPERTY_SIZE_UNITS = ["Sq Ft", "Sq Yard", "Sq Meter", "Acre"];

// Fixed workplace/location for professional categories (no dropdown, no free text).
export const FIXED_NCR_CATEGORIES = new Set(["architects", "contractors"]);

// Event service category options — user-facing selector.
export const EVENT_CATEGORY_OPTIONS = [
  "All", "Wedding", "Corporate", "Birthday", "Photography", "Catering",
  "Decor", "DJ / Music", "Anniversary", "Other",
];

// ---------------------------------------------------------------
// Education, Healthcare & Food option lists (new spec)
// ---------------------------------------------------------------
export const SCHOOL_BOARDS = ["CBSE", "ICSE", "State Board - Haryana", "State Board - UP", "IB", "Other"];
export const COLLEGE_STREAMS = ["Science", "Commerce", "Arts", "Professional"];
export const EDUCATION_MEDIUMS = ["English", "Hindi", "Both", "Other"];
export const COLLEGE_APPROVALS = ["UGC", "AICTE", "NCTE", "MCI", "Bar Council", "Other"];

// ----- Healthcare -----
export const HEALTHCARE_FACILITIES = [
  "24x7 Emergency", "ICU Available", "Ambulance Service", "Operation Theatre",
  "Diagnostic Lab", "Pharmacy", "Oxygen / Ventilator", "Maternity Services",
  "Pediatric Care", "Wheelchair Access", "Parking", "Online Appointment", "Cashless Insurance",
];
export const CLINIC_SPECIALIZATIONS = [
  "General Physician", "Dentist", "ENT", "Cardiologist", "Dermatologist",
  "Gynecologist", "Orthopaedic", "Pediatric", "Neurologist", "Psychiatrist", "Other",
];
export const DIAGNOSTIC_TEST_TYPES = ["Blood Test", "X-Ray", "MRI", "CT Scan", "Full Body Checkup"];
export const PHARMACY_TYPES = ["24x7", "Normal"];
export const DOCTOR_SPECIALIZATIONS = [
  "Cardiology", "Orthopedic", "Pediatric", "Gynecology", "Neurology",
  "Dermatology", "General Medicine", "Dentistry", "ENT", "Psychiatry", "Other",
];
export const THERAPY_TYPES = ["Pain Relief", "Sports Injury", "Post Surgery Rehab"];
export const HOME_HEALTHCARE_SERVICES = ["Nursing", "Caregiver", "Doctor Visit"];
export const EMERGENCY_SERVICE_TYPES = ["Ambulance", "Trauma Support"];
export const ALT_MED_PRACTICES = ["Ayurveda", "Homeopathy", "Naturopathy"];
export const SPECIALIZED_CARE_SPECS = ["Cardiology", "Orthopedic", "Pediatric", "Gynecology", "Neurology", "Dermatology"];

// ----- Food -----
export const FOOD_FACILITIES = [
  "Home Delivery", "Takeaway", "Dine-In", "Parking", "Online Payment",
  "Air Conditioning", "Family Seating", "Outdoor Seating", "Live Music",
  "Pet Friendly", "Wheelchair Access",
];
export const FOOD_TAGS = [
  "Best Seller", "Budget Friendly", "Premium Dining", "Family Friendly",
  "Quick Service", "Hygienic", "Popular",
];
export const CUISINE_OPTIONS = ["North Indian", "South Indian", "Chinese", "Mughlai", "Continental", "Fast Food", "Italian", "Thai", "Bengali", "Punjabi"];
export const FOOD_TYPES = ["Veg", "Non-Veg", "Both"];
export const INDOOR_OUTDOOR = ["Indoor", "Outdoor", "Both"];
export const BANQUET_LAYOUTS = INDOOR_OUTDOOR;
export const RESTAURANT_TYPES = FOOD_TYPES; // legacy alias

// -------------------------------------------------------------
// Subcategory -> Type (multi-select) map
// -------------------------------------------------------------
export const SUBCATEGORY_TYPES = {
  // Healthcare
  "healthcare::Hospital": ["General Hospital", "Nursing Home", "Emergency & Trauma Center", "Maternity Hospital", "Multi-Speciality Hospital"],
  "healthcare::Clinic": ["General Clinic", "Dental Clinic", "Skin Clinic (Dermatology)", "Eye Clinic (Ophthalmology)"],
  "healthcare::Diagnostic Center": ["Pathology Lab", "Imaging Center (X-Ray / MRI / CT Scan)", "Blood Test Center", "Full Body Checkup Center"],
  "healthcare::Pharmacy": ["24x7 Medical Store", "Retail Pharmacy", "Wholesale Pharmacy"],
  "healthcare::Doctor (Individual)": ["General Physician", "Specialist Doctor", "Surgeon", "Consultant"],
  "healthcare::Physiotherapy & Rehab": ["Physiotherapy Clinic", "Rehabilitation Center", "Sports Injury Rehab"],
  "healthcare::Home Healthcare": ["Home Nursing", "Caregiver Service", "Home Doctor Visit"],
  "healthcare::Emergency Services": ["Ambulance Service", "Trauma Support", "Emergency Response Unit"],
  "healthcare::Alternative Medicine": ["Ayurveda Clinic", "Homeopathy Clinic", "Naturopathy Center"],
  "healthcare::Specialized Care": ["Cardiology", "Orthopedic", "Pediatric", "Gynecology", "Neurology", "Dermatology"],

  // Food
  "food::Restaurant": ["Family Restaurant", "Fine Dining", "Casual Dining", "Quick Service (QSR)", "Buffet", "Multi-Cuisine", "Pure Veg", "Non-Veg"],
  "food::Cafe & Beverages": ["Coffee Cafe", "Tea Cafe", "Juice Bar", "Shake Bar", "Ice Cream Parlour"],
  "food::Fast Food & Quick Bites": ["Pizza Outlet", "Burger Outlet", "Fast Food Center"],
  "food::Sweets & Bakery": ["Sweet Shop", "Bakery", "Cake Studio"],
  "food::Catering & Tiffin": ["Tiffin Service", "Catering Service"],
  "food::Cloud Kitchen": ["Single Brand Kitchen", "Multi Brand Kitchen"],
  "food::Street Food & Dhaba": ["Street Food Stall", "Dhaba"],
  "food::Banquet & Party Food": ["Wedding Catering", "Party Catering", "Corporate Catering"],
  "food::Grocery & Daily Needs": ["Grocery Store", "Supermarket", "Dairy Booth", "Fruits & Vegetable Shop"],
  "food::Specialty Food Stores": ["Organic Store", "Meat Shop", "Fish Shop"],

  // Education
  "education::School": ["Play School", "Nursery / Kindergarten", "Primary School", "Middle School", "High School", "Senior Secondary School"],
  "education::College": ["Degree College", "Engineering College", "Polytechnic", "ITI", "B.Ed College", "Nursing College"],
  "education::Coaching Institute": ["Government Exam", "IIT-JEE", "NEET", "Board Classes", "Competitive Exams", "Language Coaching"],
  "education::Study Center": ["Tuition Center", "Library & Study Centers", "Public Library", "Reading Room", "Study Café"],
};

export function typesForSubcategory(categoryId, subcategory) {
  if (!categoryId || !subcategory) return [];
  return SUBCATEGORY_TYPES[`${categoryId}::${subcategory}`] || [];
}

// Categories that use the type multi-select in Step 1 (new spec).
export const TYPE_ENABLED_CATEGORIES = new Set(["healthcare", "food", "education"]);

// Dynamic key-detail field definitions (used for non-property / non-vehicle categories).
export const KEY_DETAIL_FIELDS = {
  businesses: [
    { key: "annual_turnover", label: "Annual Turnover", type: "text" },
    { key: "established_year", label: "Established Year", type: "number" },
  ],
  architects: [
    { key: "experience_years", label: "Years of Experience", type: "number" },
  ],
  contractors: [
    { key: "experience_years", label: "Years of Experience", type: "number" },
    { key: "service_type", label: "Service Type", type: "text" },
  ],
  "interior-designers": [
    { key: "experience_years", label: "Years of Experience", type: "number" },
  ],
  "event-services": [
    { key: "service_type", label: "Service Type", type: "text" },
  ],
  "travel-services": [
    { key: "service_type", label: "Service Type", type: "text" },
  ],
  education: [],
  healthcare: [],
  food: [],
};

// -------------------------------------------------------------
// Dynamic Name field label — depends on subcategory
// -------------------------------------------------------------
const NAME_LABEL_MAP = {
  // Healthcare
  "healthcare::Hospital": "Hospital Name",
  "healthcare::Clinic": "Clinic Name",
  "healthcare::Diagnostic Center": "Lab / Diagnostic Center Name",
  "healthcare::Pharmacy": "Pharmacy Name",
  "healthcare::Doctor (Individual)": "Doctor Name",
  "healthcare::Physiotherapy & Rehab": "Physiotherapy Center Name",
  "healthcare::Home Healthcare": "Service Provider Name",
  "healthcare::Emergency Services": "Service Name",
  "healthcare::Alternative Medicine": "Clinic / Center Name",
  "healthcare::Specialized Care": "Center / Doctor Name",
  // Education
  "education::School": "School Name",
  "education::College": "College Name",
  "education::Coaching Institute": "Institute Name",
  "education::Study Center": "Center Name",
  // Food
  "food::Restaurant": "Restaurant Name",
  "food::Cafe & Beverages": "Cafe Name",
  "food::Fast Food & Quick Bites": "Outlet Name",
  "food::Sweets & Bakery": "Shop Name",
  "food::Catering & Tiffin": "Service Name",
  "food::Cloud Kitchen": "Kitchen Name",
  "food::Street Food & Dhaba": "Stall / Dhaba Name",
  "food::Banquet & Party Food": "Banquet / Service Name",
  "food::Grocery & Daily Needs": "Store Name",
  "food::Specialty Food Stores": "Store Name",
};

export function nameLabelFor(categoryId, subcategory) {
  if (!categoryId) return "Business Name";
  if (subcategory) {
    const specific = NAME_LABEL_MAP[`${categoryId}::${subcategory}`];
    if (specific) return specific;
  }
  if (categoryId === "healthcare") return "Business Name";
  if (categoryId === "education") return "Institution Name";
  if (categoryId === "food") return "Business Name";
  return "Business Name";
}

// -------------------------------------------------------------
// Common fields shared across all subcategories of a category
// -------------------------------------------------------------
export const HEALTHCARE_COMMON_FIELDS = [
  { key: "open_hours", label: "Open Hours", type: "text", required: true, placeholder: "e.g. 9 AM – 8 PM" },
  { key: "mobile_number", label: "Mobile Number", type: "text", required: true, placeholder: "10-digit mobile" },
  { key: "email", label: "Email", type: "email", required: false, placeholder: "Optional" },
  { key: "website", label: "Website", type: "text", required: false, placeholder: "Optional" },
  { key: "consultation_fees", label: "Consultation / OPD Fees (\u20B9)", type: "number", required: false, placeholder: "Optional" },
];

export const FOOD_COMMON_FIELDS = [
  { key: "owner_name", label: "Owner Name", type: "text", required: true },
  { key: "mobile_number", label: "Mobile Number", type: "text", required: true, placeholder: "10-digit mobile" },
  { key: "email", label: "Email", type: "email", required: false, placeholder: "Optional" },
  { key: "website", label: "Website", type: "text", required: false, placeholder: "Optional" },
  { key: "opening_time", label: "Opening Time", type: "text", required: true, placeholder: "e.g. 10:00 AM" },
  { key: "closing_time", label: "Closing Time", type: "text", required: true, placeholder: "e.g. 11:00 PM" },
  { key: "price_range", label: "Price Range (\u20B9)", type: "text", required: false, placeholder: "e.g. 200 to 1000" },
  { key: "seating_capacity", label: "Seating Capacity", type: "number", required: true },
  { key: "layout", label: "Indoor / Outdoor / Both", type: "select", options: INDOOR_OUTDOOR, required: true },
];

export const EDUCATION_COMMON_FIELDS = [
  { key: "phone_number", label: "Phone Number", type: "text", required: true, placeholder: "10-digit mobile" },
  { key: "email", label: "Email", type: "email", required: false, placeholder: "Optional" },
  { key: "website", label: "Website", type: "text", required: false, placeholder: "Optional" },
];

// ----- Beauty / Fitness / EV shared field sets -----
export const BEAUTY_COMMON_FIELDS = [
  { key: "salon_name", label: "Salon Name", type: "text", required: true, placeholder: "e.g. Glow Beauty Studio" },
  { key: "owner_name", label: "Owner Name", type: "text", required: true },
  { key: "contact_number", label: "Contact Number", type: "text", required: true, placeholder: "10-digit mobile" },
  { key: "opening_hours", label: "Opening Hours", type: "time_range", required: true },
  { key: "price_list", label: "Price List", type: "textarea", required: true, placeholder: "e.g. Haircut ₹300, Facial ₹800, Bridal Package ₹15000" },
  { key: "home_service", label: "Home Service Available", type: "checkbox" },
  { key: "parking_available", label: "Parking Available", type: "checkbox" },
  { key: "online_booking", label: "Online Appointment Booking", type: "checkbox" },
];

export const FITNESS_COMMON_FIELDS = [
  { key: "center_name", label: "Gym / Center Name", type: "text", required: true, placeholder: "e.g. Iron Body Fitness" },
  { key: "owner_name", label: "Owner Name", type: "text", required: true },
  { key: "contact_number", label: "Contact Number", type: "text", required: true, placeholder: "10-digit mobile" },
  { key: "opening_hours", label: "Opening Hours", type: "time_range", required: true },
  { key: "pricing_packages", label: "Pricing / Packages", type: "textarea", required: true, placeholder: "e.g. Monthly ₹1500, Quarterly ₹4000, Yearly ₹12000" },
  { key: "personal_training", label: "Personal Training Available", type: "checkbox" },
  { key: "home_training", label: "Home Training Available", type: "checkbox" },
  { key: "online_sessions", label: "Online Sessions Available", type: "checkbox" },
  { key: "parking_available", label: "Parking Available", type: "checkbox" },
  { key: "free_trial", label: "Free Trial Available", type: "checkbox" },
];

export const EV_CHARGING_SPEEDS = ["Slow (3.3 kW)", "Fast (7.4 kW)", "Rapid (22 kW)", "Super Fast (50 kW)", "Ultra Fast (100 kW+)"];
export const EV_CHARGER_TYPES = ["Type 2 AC", "CCS2 (DC)", "CHAdeMO", "Bharat AC-001", "Bharat DC-001", "GB/T"];

export const EV_COMMON_FIELDS = [
  { key: "station_name", label: "Station Name", type: "text", required: true, placeholder: "e.g. Pataudi EV Hub" },
  { key: "owner_name", label: "Owner Name", type: "text", required: true },
  { key: "contact_number", label: "Contact Number", type: "text", required: true, placeholder: "10-digit mobile" },
  { key: "opening_hours", label: "Opening Hours", type: "time_range", required: true, placeholder: "or 24x7" },
  { key: "charging_price", label: "Charging Price (per kWh / per hour)", type: "text", required: true, placeholder: "e.g. ₹18 / kWh" },
  { key: "charging_speeds", label: "Charging Speed", type: "multiselect", options: EV_CHARGING_SPEEDS, required: true },
  { key: "charger_types", label: "Available Chargers", type: "multiselect", options: EV_CHARGER_TYPES, required: true },
  { key: "fast_charging", label: "Fast Charging Available", type: "checkbox" },
  { key: "parking_available", label: "Parking Available", type: "checkbox" },
  { key: "available_24x7", label: "24x7 Available", type: "checkbox" },
  { key: "online_booking", label: "Online Booking Available", type: "checkbox" },
];

// -------------------------------------------------------------
// Subcategory-specific dynamic fields (Step 2)
// -------------------------------------------------------------
export const SUBCATEGORY_FIELDS = {
  // ---------- Healthcare ----------
  "healthcare::Hospital": [
    { key: "doctor_name", label: "Doctor Name", type: "text" },
    { key: "total_beds", label: "Total Beds", type: "number", required: true },
    { key: "available_24x7", label: "24x7 Available", type: "checkbox" },
  ],
  "healthcare::Clinic": [
    { key: "doctor_name", label: "Doctor Name", type: "text", required: true },
    { key: "specialization", label: "Specialization", type: "select", options: CLINIC_SPECIALIZATIONS, required: true },
  ],
  "healthcare::Diagnostic Center": [
    { key: "test_types", label: "Test Types", type: "multiselect", options: DIAGNOSTIC_TEST_TYPES, required: true },
    { key: "home_collection", label: "Home Sample Collection", type: "checkbox" },
  ],
  "healthcare::Pharmacy": [
    { key: "pharmacy_type", label: "Pharmacy Type", type: "select", options: PHARMACY_TYPES, required: true },
    { key: "home_delivery", label: "Home Delivery", type: "checkbox" },
  ],
  "healthcare::Doctor (Individual)": [
    { key: "specialization", label: "Specialization", type: "select", options: DOCTOR_SPECIALIZATIONS, required: true },
    { key: "experience_years", label: "Experience (Years)", type: "number", required: true },
  ],
  "healthcare::Physiotherapy & Rehab": [
    { key: "therapy_types", label: "Therapy Types", type: "multiselect", options: THERAPY_TYPES, required: true },
  ],
  "healthcare::Home Healthcare": [
    { key: "services_offered", label: "Services Offered", type: "multiselect", options: HOME_HEALTHCARE_SERVICES, required: true },
  ],
  "healthcare::Emergency Services": [
    { key: "service_type", label: "Service Type", type: "select", options: EMERGENCY_SERVICE_TYPES, required: true },
  ],
  "healthcare::Alternative Medicine": [
    { key: "practice_types", label: "Practice Type", type: "multiselect", options: ALT_MED_PRACTICES, required: true },
  ],
  "healthcare::Specialized Care": [
    { key: "specializations", label: "Specialization", type: "multiselect", options: SPECIALIZED_CARE_SPECS, required: true },
  ],

  // ---------- Food ----------
  "food::Restaurant": [
    { key: "cuisines", label: "Cuisine", type: "multiselect", options: CUISINE_OPTIONS, required: true },
    { key: "food_type", label: "Food Type", type: "select", options: FOOD_TYPES, required: true },
  ],
  "food::Cafe & Beverages": [
    { key: "specializations", label: "Specialization", type: "multiselect", options: ["Coffee", "Tea", "Juice", "Desserts"], required: true },
    { key: "wifi_available", label: "WiFi Available", type: "checkbox" },
  ],
  "food::Fast Food & Quick Bites": [
    { key: "food_items", label: "Food Items", type: "multiselect", options: ["Pizza", "Burger", "Sandwich", "Rolls"], required: true },
    { key: "takeaway_available", label: "Takeaway Available", type: "checkbox" },
  ],
  "food::Sweets & Bakery": [
    { key: "products", label: "Products", type: "multiselect", options: ["Cakes", "Pastries", "Sweets"], required: true },
    { key: "custom_cake_orders", label: "Custom Cake Orders", type: "checkbox" },
    { key: "eggless_available", label: "Eggless Available", type: "checkbox" },
  ],
  "food::Catering & Tiffin": [
    { key: "food_type", label: "Veg / Non-Veg / Both", type: "select", options: FOOD_TYPES, required: true },
    { key: "service_area_km", label: "Service Area (KM)", type: "number", required: true },
    { key: "minimum_order", label: "Minimum Order (\u20B9)", type: "number", required: true },
  ],
  "food::Cloud Kitchen": [
    { key: "cuisines", label: "Cuisine", type: "multiselect", options: CUISINE_OPTIONS, required: true },
    { key: "delivery_platforms", label: "Delivery Platforms", type: "multiselect", options: ["Zomato", "Swiggy", "Own App"] },
    { key: "delivery_radius_km", label: "Delivery Radius (KM)", type: "number", required: true },
  ],
  "food::Street Food & Dhaba": [
    { key: "food_type", label: "Food Type", type: "select", options: FOOD_TYPES, required: true },
  ],
  "food::Banquet & Party Food": [
    { key: "event_types", label: "Event Types", type: "multiselect", options: ["Wedding", "Birthday", "Corporate"], required: true },
    { key: "seating_capacity_event", label: "Seating Capacity", type: "number", required: true },
  ],
  "food::Grocery & Daily Needs": [
    { key: "product_categories", label: "Product Categories", type: "multiselect", options: ["Grocery", "Dairy", "Fruits & Veg"], required: true },
    { key: "home_delivery", label: "Home Delivery", type: "checkbox" },
  ],
  "food::Specialty Food Stores": [
    { key: "specialty", label: "Specialty", type: "multiselect", options: ["Organic", "Meat", "Fish"], required: true },
    { key: "fresh_stock_daily", label: "Fresh Stock Daily", type: "checkbox" },
  ],

  // ---------- Education ----------
  "education::School": [
    { key: "class_range", label: "Class Range", type: "text", required: true, placeholder: "e.g. Nursery to 12th" },
    { key: "medium", label: "Medium", type: "select", options: EDUCATION_MEDIUMS },
    { key: "board", label: "Board", type: "select", options: SCHOOL_BOARDS },
    { key: "principal_name", label: "Principal Name", type: "text", required: true },
    { key: "num_teachers", label: "Number of Teachers", type: "number", required: true },
  ],
  "education::College": [
    { key: "courses", label: "Courses Offered", type: "multiselect", options: ["B.A", "B.Com", "B.Sc", "B.Tech", "Diploma", "M.A", "M.Com", "M.Sc"], required: true },
    { key: "affiliation", label: "Affiliation / University", type: "text" },
    { key: "approval", label: "Approval", type: "select", options: COLLEGE_APPROVALS },
    { key: "total_faculty", label: "Total Faculty Count", type: "number" },
  ],
  "education::Coaching Institute": [
    { key: "exam_focus", label: "Exams / Courses", type: "text", required: true, placeholder: "e.g. IIT-JEE, NEET" },
    { key: "batch_timing", label: "Batch Timing", type: "text" },
    { key: "batch_size", label: "Batch Size", type: "number" },
    { key: "fees", label: "Fees / Range", type: "text" },
    { key: "faculty_experience", label: "Faculty Experience", type: "text" },
  ],
  "education::Study Center": [
    { key: "total_seats", label: "Total Seats", type: "number", required: true },
    { key: "opening_time", label: "Opening Time", type: "text" },
    { key: "closing_time", label: "Closing Time", type: "text" },
    { key: "ac_type", label: "AC / Non-AC", type: "select", options: ["AC", "Non-AC"] },
    { key: "home_tuition_available", label: "Home Tuition Available", type: "checkbox" },
  ],
};

// -------------------------------------------------------------
// Facilities checklist (Step 2 common – multi-select per category)
// -------------------------------------------------------------
export const CATEGORY_FACILITIES = {
  healthcare: HEALTHCARE_FACILITIES,
  food: FOOD_FACILITIES,
  "education::School": ["Air Conditioner", "Playground", "Computer Lab", "Library", "Physics Lab", "Chemistry Lab", "Biology Lab", "Smart Class", "Sports Items", "Specific Sports Ground"],
  "education::College": ["Library", "Labs", "Hostel", "WiFi", "Sports", "Cafeteria"],
  "education::Coaching Institute": ["AC", "Test Series", "Study Material", "Online Classes", "Doubt Sessions"],
  "education::Study Center": ["WiFi", "Charging Points", "Silent Zone", "Locker Facility", "Library Access", "Cafeteria"],
};

export function facilitiesFor(categoryId, subcategory) {
  if (!categoryId) return [];
  const bySub = CATEGORY_FACILITIES[`${categoryId}::${subcategory}`];
  if (bySub) return bySub;
  return CATEGORY_FACILITIES[categoryId] || [];
}

export function fieldsForCategory(categoryId, subcategory) {
  const base = KEY_DETAIL_FIELDS[categoryId] || [];
  // Prepend a dynamic Name field whose label depends on the subcategory.
  const nameField = {
    key: "name",
    label: nameLabelFor(categoryId, subcategory),
    type: "text",
    required: true,
    placeholder: `Enter ${nameLabelFor(categoryId, subcategory).toLowerCase()}`,
  };
  if (categoryId === "healthcare") {
    const sub = subcategory ? SUBCATEGORY_FIELDS[`healthcare::${subcategory}`] || [] : [];
    return [nameField, ...HEALTHCARE_COMMON_FIELDS, ...sub];
  }
  if (categoryId === "food") {
    const sub = subcategory ? SUBCATEGORY_FIELDS[`food::${subcategory}`] || [] : [];
    return [nameField, ...FOOD_COMMON_FIELDS, ...sub];
  }
  if (categoryId === "education") {
    const sub = subcategory ? SUBCATEGORY_FIELDS[`education::${subcategory}`] || [] : [];
    return [nameField, ...EDUCATION_COMMON_FIELDS, ...sub];
  }
  if (categoryId === "beauty") return BEAUTY_COMMON_FIELDS;
  if (categoryId === "fitness") return FITNESS_COMMON_FIELDS;
  if (categoryId === "ev-charging") return EV_COMMON_FIELDS;
  return base;
}

export function categoryById(id) {
  return CATEGORIES.find((c) => c.id === id);
}

export function priceLabelFor(price, priceType) {
  if (priceType === "on_request" || price == null) return "Contact for Price";
  const n = Number(price);
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2).replace(/\.00$/, "")} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2).replace(/\.00$/, "")} Lakh`;
  return `₹${n.toLocaleString("en-IN")}`;
}

export function slugify(text) {
  return (text || "").toLowerCase().replace(/[^\w\s-]/g, "").trim().replace(/[\s_-]+/g, "-").slice(0, 60) || "listing";
}
